import axios from "axios";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import Select from "react-select";
import { toast } from "react-toastify";

const HOURS_PER_DAY = 6;
const numberValue = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};
const staffName = (staff) => {
    const user = staff?.user || {};
    return [
        staff?.matricule,
        user.last_name,
        user.family_name,
        user.first_name,
    ]
        .filter(Boolean)
        .join(" ");
};
const className = (item) =>
    [
        item?.class?.short_entitled_class,
        item?.title,
        item?.section?.short_entitled_section,
    ]
        .filter(Boolean)
        .join(" ");

class SectionclasselessonForm extends Component {
    state = {
        id: "",
        max_exam: "",
        max_evaluation: "",
        indice: "",
        sectionclasse_id: "",
        lesson_id: "",
        staff_id: "",
        domaine_id: "",
        week_hour: "",
        error: "",
        fieldErrors: {},
        lessons: [],
        domaines: [],
        loadingOptions: false,
        saving: false,
        deleting: false,
        title: "",
    };

    prepareForm = () => {
        const data = this.props.formData;
        const classId =
            data?.sectionclasseId ||
            data?.sectionclass?.id ||
            this.props.sectionclasse ||
            "";
        const classLessons =
            this.props.lessonsByClass.find(
                (item) => String(item.id) === String(classId)
            )?.sectionclasselessons || [];
        const nextIndex =
            classLessons.reduce(
                (max, item) => Math.max(max, numberValue(item.indice)),
                0
            ) + 1;
        this.setState({
            id: data?.id || "",
            max_exam: data?.max_examen ?? "",
            max_evaluation: data?.max_evaluation ?? "",
            indice: data?.indice || nextIndex,
            sectionclasse_id: classId,
            lesson_id: data?.lesson?.id || data?.lessonId || "",
            staff_id: data?.staff?.id || data?.staffId || "",
            domaine_id: data?.domaineId || data?.domaine?.id || "",
            week_hour: data?.week_hour ?? "",
            title: data ? "Modifier l’affectation" : "Nouvelle affectation",
            error: "",
            fieldErrors: {},
            saving: false,
            deleting: false,
        });
        this.loadOptions();
    };

    loadOptions = async () => {
        this.setState({ loadingOptions: true });
        try {
            const [lessons, domaines] = await Promise.all([
                axios.get("lessons"),
                axios.get("domaines"),
            ]);
            this.setState({
                lessons: lessons.data || [],
                domaines: domaines.data || [],
            });
        } catch (error) {
            this.setState({
                error:
                    error.response?.data?.msg ||
                    "Impossible de charger les listes.",
            });
        } finally {
            this.setState({ loadingOptions: false });
        }
    };

    handleInput = ({ target }) =>
        this.setState((state) => ({
            [target.name]: target.value,
            error: "",
            fieldErrors: { ...state.fieldErrors, [target.name]: "" },
        }));

    teacherSummary = () => {
        const staff = this.props.staffs.find(
            (item) => String(item.id) === String(this.state.staff_id)
        );
        if (!staff) return null;
        const validDays = new Set(
            this.props.days.map((day) => String(day.id))
        );
        const dayCount = new Set(
            (staff.daystaffs || [])
                .filter(
                    (item) =>
                        Number(item.actif) === 1 &&
                        validDays.has(String(item.dayId))
                )
                .map((item) => String(item.dayId))
        ).size;
        const currentHours = (staff.sectionclasselessons || [])
            .filter((item) => String(item.id) !== String(this.state.id))
            .reduce(
                (sum, item) => sum + numberValue(item.week_hour),
                0
            );
        const totalHours =
            currentHours + numberValue(this.state.week_hour);
        const capacity = dayCount * HOURS_PER_DAY;
        return {
            dayCount,
            currentHours,
            totalHours,
            capacity,
            overloaded: totalHours > capacity,
        };
    };

    validate = () => {
        const errors = {};
        if (!this.state.sectionclasse_id)
            errors.sectionclasse_id = "La classe est obligatoire.";
        if (!this.state.domaine_id)
            errors.domaine_id = "Le domaine est obligatoire.";
        if (!this.state.lesson_id)
            errors.lesson_id = "Le cours est obligatoire.";
        if (!this.state.staff_id)
            errors.staff_id = "Le titulaire est obligatoire.";

        const selectedClass = this.props.lessonsByClass.find(
            (item) =>
                String(item.id) === String(this.state.sectionclasse_id)
        );
        const duplicate = (selectedClass?.sectionclasselessons || []).some(
            (item) =>
                String(item.id) !== String(this.state.id) &&
                String(item.lesson?.id || item.lessonId) ===
                    String(this.state.lesson_id)
        );
        if (duplicate)
            errors.lesson_id = "Ce cours existe déjà dans cette classe.";

        this.setState({ fieldErrors: errors });
        return Object.keys(errors).length === 0;
    };

    scheduleWarnings = () => {
        const warnings = {};
        const teacher = this.teacherSummary();

        if (numberValue(this.state.week_hour) <= 0)
            warnings.week_hour =
                "Aucune heure hebdomadaire : ce cours ne sera pas placé automatiquement dans l’horaire.";
        if (teacher && teacher.dayCount === 0)
            warnings.staff_id =
                "Ce professeur n’a aucun jour actif. L’affectation sera enregistrée, mais pas planifiable.";
        else if (teacher?.overloaded)
            warnings.week_hour = `Surcharge prévue : ${teacher.totalHours}h affectées pour ${teacher.capacity}h disponibles.`;

        return warnings;
    };
    save = async () => {
        if (!this.validate()) return;
        const data = {
            sectionclasseId: this.state.sectionclasse_id,
            sectionclassId: this.state.sectionclasse_id,
            lessonId: this.state.lesson_id,
            staffId: this.state.staff_id,
            max_examen:
                this.state.max_exam === ""
                    ? null
                    : numberValue(this.state.max_exam),
            max_evaluation:
                this.state.max_evaluation === ""
                    ? null
                    : numberValue(this.state.max_evaluation),
            indice:
                this.state.indice === ""
                    ? null
                    : numberValue(this.state.indice),
            domaineId: this.state.domaine_id,
            week_hour: numberValue(this.state.week_hour),
            operation: this.state.id ? "Editer" : "Ajouter",
        };
        this.setState({ saving: true, error: "" });
        try {
            const response = this.state.id
                ? await axios.put(
                      `sectionclasselessons/${this.state.id}`,
                      data
                  )
                : await axios.post("sectionclasselessons", data);
            toast.success(
                response?.data?.msg || "Affectation enregistrée."
            );
            this.props.showModal();
        } catch (error) {
            const message =
                error.response?.data?.msg ||
                "L’affectation n’a pas pu être enregistrée.";
            this.setState({ error: message });
            toast.error(message);
        } finally {
            this.setState({ saving: false });
        }
    };

    delete = async () => {
        if (
            !window.confirm(
                "Supprimer cette affectation ? Les horaires liés peuvent être affectés."
            )
        )
            return;
        this.setState({ deleting: true, error: "" });
        try {
            const response = await axios.delete(
                `sectionclasselessons/${this.state.id}`
            );
            toast.success(response?.data?.msg || "Affectation supprimée.");
            this.props.showModal();
        } catch (error) {
            const message =
                error.response?.data?.msg ||
                "Cette affectation ne peut pas être supprimée.";
            this.setState({ error: message, deleting: false });
            toast.error(message);
        }
    };

    selectField = (label, field, options, placeholder, icon) => (
        <div className="col-md-6">
            <label className="scl-form-label">
                <FeatherIcon icon={icon} size="15" /> {label}
            </label>
            <Select
                classNamePrefix="scl-select"
                value={
                    options.find(
                        (item) =>
                            String(item.value) ===
                            String(this.state[field])
                    ) || null
                }
                onChange={(selected) =>
                    this.setState((state) => ({
                        [field]: selected?.value || "",
                        error: "",
                        fieldErrors: {
                            ...state.fieldErrors,
                            [field]: "",
                        },
                    }))
                }
                options={options}
                placeholder={placeholder}
                noOptionsMessage={() => "Aucun résultat"}
                isLoading={this.state.loadingOptions}
            />
            {this.state.fieldErrors[field] && (
                <small className="scl-field-error">
                    {this.state.fieldErrors[field]}
                </small>
            )}
        </div>
    );

    numberField = (label, name, placeholder, min = 0, warning = "") => (
        <div className="col-md-3">
            <label className="scl-form-label">{label}</label>
            <input
                type="number"
                min={min}
                step="1"
                className="form-control"
                name={name}
                value={this.state[name]}
                onChange={this.handleInput}
                placeholder={placeholder}
            />
            {this.state.fieldErrors[name] && (
                <small className="scl-field-error">
                    {this.state.fieldErrors[name]}
                </small>
            )}
            {!this.state.fieldErrors[name] && warning && (
                <small className="scl-field-warning">{warning}</small>
            )}
        </div>
    );

    render() {
        const sections = this.props.sectionclasses
            .map((item) => ({ value: item.id, label: className(item) }))
            .sort((a, b) => a.label.localeCompare(b.label));
        const lessons = this.state.lessons
            .map((item) => ({
                value: item.id,
                label:
                    item.entitled_lesson ||
                    item.short_entitled_lesson ||
                    "Cours",
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
        const domaines = this.state.domaines
            .map((item) => ({ value: item.id, label: item.title }))
            .sort((a, b) => a.label.localeCompare(b.label));
        const staffs = this.props.staffs
            .map((item) => ({ value: item.id, label: staffName(item) }))
            .sort((a, b) => a.label.localeCompare(b.label));
        const teacher = this.teacherSummary();
        const scheduleWarnings = this.scheduleWarnings();

        return (
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                onEntered={this.prepareForm}
                size="lg"
                centered
                backdrop="static"
                dialogClassName="scl-form-modal"
            >
                <Modal.Header closeButton>
                    <div>
                        <span className="scl-eyebrow">Cours et titulaire</span>
                        <Modal.Title>{this.state.title}</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {this.state.error && (
                        <div className="alert alert-danger py-2">
                            {this.state.error}
                        </div>
                    )}
                    <div className="row g-3">
                        {this.selectField(
                            "Classe",
                            "sectionclasse_id",
                            sections,
                            "Choisir une classe",
                            "layers"
                        )}
                        {this.selectField(
                            "Domaine",
                            "domaine_id",
                            domaines,
                            "Choisir un domaine",
                            "folder"
                        )}
                        {this.selectField(
                            "Cours",
                            "lesson_id",
                            lessons,
                            "Choisir un cours",
                            "book-open"
                        )}
                        {this.selectField(
                            "Professeur titulaire",
                            "staff_id",
                            staffs,
                            "Choisir un professeur",
                            "user"
                        )}
                        {scheduleWarnings.staff_id && (
                            <div className="col-12">
                                <div className="scl-inline-warning">
                                    <FeatherIcon icon="alert-triangle" size="16" />
                                    <span>{scheduleWarnings.staff_id}</span>
                                </div>
                            </div>
                        )}
                    </div>

                    {teacher && (
                        <div
                            className={`scl-capacity ${
                                teacher.overloaded || !teacher.dayCount
                                    ? "has-issue"
                                    : ""
                            }`}
                        >
                            <div>
                                <FeatherIcon icon="calendar" size="19" />
                                <span>
                                    <strong>
                                        {teacher.dayCount} jour(s)
                                        disponible(s)
                                    </strong>
                                    <small>
                                        Capacité calculée à {HOURS_PER_DAY}h par
                                        jour
                                    </small>
                                </span>
                            </div>
                            <div>
                                <strong>
                                    {teacher.totalHours}h / {teacher.capacity}h
                                </strong>
                                <small>charge après affectation</small>
                            </div>
                        </div>
                    )}

                    <div className="scl-form-section">
                        <div className="scl-section-heading">
                            <span>Exigences hebdomadaires</span>
                            <small>
                                Ces heures alimentent directement la génération
                                de l’horaire.
                            </small>
                        </div>
                        <div className="row g-3">
                            {this.numberField(
                                "Heures / semaine",
                                "week_hour",
                                "Ex. 4",
                                0,
                                scheduleWarnings.week_hour
                            )}
                            {this.numberField(
                                "Max. évaluation",
                                "max_evaluation",
                                "Ex. 20"
                            )}
                            {this.numberField(
                                "Max. examen",
                                "max_exam",
                                "Ex. 40"
                            )}
                            {this.numberField(
                                "Ordre au bulletin",
                                "indice",
                                "Ex. 1",
                                1
                            )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {this.state.id && (
                        <button
                            type="button"
                            className="btn btn-outline-danger me-auto"
                            onClick={this.delete}
                            disabled={this.state.deleting || this.state.saving}
                        >
                            <FeatherIcon icon="trash-2" size="16" />{" "}
                            {this.state.deleting
                                ? "Suppression…"
                                : "Supprimer"}
                        </button>
                    )}
                    <button
                        type="button"
                        className="btn btn-light"
                        onClick={this.props.showModal}
                        disabled={this.state.saving}
                    >
                        Annuler
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.save}
                        disabled={
                            this.state.saving || this.state.loadingOptions
                        }
                    >
                        <FeatherIcon icon="check" size="17" />{" "}
                        {this.state.saving
                            ? "Enregistrement…"
                            : "Enregistrer l’affectation"}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

SectionclasselessonForm.defaultProps = {
    staffs: [],
    lessonsByClass: [],
    sectionclasses: [],
    days: [],
};

export default SectionclasselessonForm;
